<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong class="text-danger">
                Verification not found
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background text-center">
        The verification link used was not found in our records, or it was already used.
        <br />
        <small>You can try to <router-link class="thick-font" to="login">Login</router-link> or <router-link class="thick-font" to="register">Register</router-link></small>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerificationNotFound',
};
</script>



// WEBPACK FOOTER //
// src/components/auth/VerificationNotFound.vue